module.exports = __webpack_public_path__ + "static/media/facebook.e266cd0b.svg";